/**
 * @deprecated Prefer to use the ArrayDecorator
 */
export default class ArrayUtil {
  static DEFAULT_INDEX = -1;

  static findFirst<T extends any>(arr: Array<T>, predicateFunc: (elt: T) => boolean): T {
    if (arr.length > 0) {
      for (const item of arr) {
        if (predicateFunc(item)) return item;
      }
    }

    return null;
  }

  static findElement<T>(arr: Array<T>, elt: T): T {
    return this.findFirst(arr, (item: T) => item === elt);
  }

  static findFirstIndex<T extends any>(arr: Array<T>, predicateFunc: (elt: T) => boolean): number {
    if (arr.length > 0) {
      let idx = 0;
      for (const item of arr) {
        if (predicateFunc(item)) return idx;
        idx++;
      }
    }

    return this.DEFAULT_INDEX;
  }

  static findElementIndex<T>(arr: Array<T>, elt: T): number {
    return this.findFirstIndex(arr, (item: T) => item === elt);
  }

  static contains<T>(arr: Array<T>, predicateFunc: (elt: T) => boolean): boolean {
    return this.findFirstIndex(arr, predicateFunc) > this.DEFAULT_INDEX;
  }

  static containsElement<T>(arr: Array<T>, elt: T): boolean {
    return this.contains(arr, (item: T) => item === elt);
  }

  static remove<T>(arr: Array<T>, predicateFunc: (elt: T) => boolean) {
    let removed = false;
    let index: number;

    while ((index = this.findFirstIndex(arr, predicateFunc)) > this.DEFAULT_INDEX) {
      arr.splice(index, 1);
      removed = true;
    }

    return removed;
  }

  static removeElement<T>(arr: Array<T>, elt: T): boolean {
    return this.remove(arr, (item: T) => item === elt);
  }
}
